export default {
  urlsWithoutInterceptors: ['/general/logging/client'],
  systemTitle: {
    fullName: 'ИС "Дополнительное Образование"',
    shortName: 'ИС "ДО"',
  },
  routing: {
    authPage: {
      path: '/auth',
      name: 'Авторизация в системе',
    },
    homePage: {
      path: '/programs',
      name: 'Программы',
    },
    enrollPage: {
      path: '/enroll',
      name: 'Регистрация',
    },
  },
  mobileWidth: 768,
  defaultWidth: 1000,
}
